const atLeastOneUppercaseAndLowercase = (value: string) => /^(?=.*[A-ZÅÄÖ])(?=.*[a-zåäö]).*$/.test(value);

export default atLeastOneUppercaseAndLowercase;
